import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchEntity } from "../../Services/fetchApi";
import GenericTable from './GenericTable';
import { Button } from 'reactstrap';
import { useEffect } from "react";
import LoadingAnimation from "../Form/LoadingAnimation";
import entities from "../../utils/entities";

export interface Column {
    accessor(x: unknown): unknown;
    Cell(x: { row: unknown }): string | JSX.Element;
}

interface props {
    route: string;
    item?: { id: string };
    addEntity: Function;
    entity: Partial<typeof entities[keyof typeof entities]> & {
        name: string, defaultStatus?: string, getAll?: (...params: unknown[]) => string,
        getByStatus?: (...params: unknown[]) => string, columns?: any, id: string
    };
    parentEntity?: typeof entities[keyof typeof entities];
    actions: Record<string, unknown>[];
    title: string | JSX.Element;
    heightOffset?: number | null;
    headerHeight?: number | null;
    parentHeight?: number | null;
    dateFrom?: string;
    dateTo?: string;
    fromChange?: string;
    toChange?: string;
}

const EntityDataTable = ({ route, item, addEntity, entity, actions, title, heightOffset, parentHeight, dateFrom, dateTo, fromChange, toChange }: props) => {
    const [status, setStatus] = useState(entity.defaultStatus);
    const params = useParams();
    const name = entity.name;
    const fetchURld = (entity.getAll ?? entity.getByStatus)!({ ...params, id: item?.id, status, name });
    const [list, loading, error, refresh] = useFetchEntity(entity as any, { ...params, id: item?.id, status });
    const [newParentHeight, setParentHeight] = useState(parentHeight);
    const ref = useRef({ clientHeight: null } as unknown as HTMLDivElement);
    const clientHeight = ref?.current.clientHeight;

    useEffect(() => {
        if (parentHeight && clientHeight) {
            setParentHeight(parentHeight - (clientHeight + (heightOffset ? heightOffset : 0)));
        }
    }, [clientHeight, parentHeight, heightOffset, title]);
    return <React.Fragment>
        <div ref={ref} style={{ display: 'flex' }} >{title}
            {error ? <React.Fragment><h5>Error Loading </h5><Button onClick={() => refresh()}>Refresh</Button></React.Fragment> : null}</div>
        {!fetchURld ? <h3>No URL</h3> : null}
        {loading ? <LoadingAnimation /> : <GenericTable
            entity={entity}
            addEntity={addEntity}

            noData={'No ' + entity.title + ' available'}
            columns={typeof (entity.columns) === 'function' ? entity.columns({ route, item: item! }) : entity.columns}
            data={Array.isArray(list) && !error ? list : []}
            actions={actions}
            status={status}
            onStatusSelect={setStatus}
            style={{ height: '100%' }}
            parentHeight={newParentHeight}
            dateFrom={dateFrom}
            dateTo={dateTo}
            fromChange={fromChange}
            toChange={toChange} />}
    </React.Fragment>

};

export default EntityDataTable;